import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setAPIErrorCURL } from "@/app_redux/reducers/slices/ui_states_slice";
import { useCallback } from "react";

export const useCurlLogger = () => {
  const dispatch = useAppDispatch();

  const sendCurl = useCallback((curl: string) => {
    dispatch(setAPIErrorCURL(curl));
  }, [dispatch]);

  const removeCurl = useCallback(() => {
    dispatch(setAPIErrorCURL(null));
  }, [dispatch]);

  return { sendCurl, removeCurl };
};
